
const BASE_URL = '/api/college_manage'
// import qs from 'qs'
import axios from '../config/axios.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
export const keyServer = {
  profession: (params) => {
    return axios.get(`${BASE_URL}/sysDictionary/getByKey`, {params: params}, config).then(res => res.data)
  }
}


// WEBPACK FOOTER //
// ./src/api/server/syskey.js